import { MultilineTextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../../components/ApplicationQuestionReviewItem';
import { usePropertyWorkNeededDescription } from '../../../../../../queries/PropertyFields/BridgeFields';

interface RemainingWorkDescriptionProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const RemainingWorkDescription: React.FC<RemainingWorkDescriptionProps> = ({
    propertyGuid,
    required = false,
    isReview = false,
}) => {
    const label = 'Describe Remaining Work';

    const [workNeededDescription, set_workNeededDescription] = usePropertyWorkNeededDescription(propertyGuid);

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={workNeededDescription}
                />
            ) : (
                <MultilineTextBox
                    id='remainingWork'
                    value={workNeededDescription}
                    onChange={set_workNeededDescription}
                    label={label}
                    required={required}
                />
            )}
        </>
    );
};
